import React from 'react';

export enum AppRoutesPaths {
  JoveHome = 'https://jove.co',
  Home = '/',
  BusinessType = '/business-insurance/business-type',
  CompanySearch = '/business-insurance/company-search',
  BusinessActivities = '/business-insurance/business-activities',
  BusinessTurnover = '/business-insurance/business-turnover',
  BusinessEmployees = '/business-insurance/business-employees',
  ChooseCover = '/business-insurance/choose-cover',
  UserAgreements = '/business-insurance/user-agreements',
  PaymentSuccess = '/business-insurance/payment-success',
  PersonalDetails = '/business-insurance/personal-details',
  BusinessCustomers = '/business-insurance/business-customers',
  BusinessCustomersTurnover = '/business-insurance/business-customers-turnover',
  BusinessAddress = '/business-insurance/business-address',
  AdditionalCover = '/business-insurance/additional-cover',
  ConfirmInformation = '/business-insurance/confirm-information',

  Declarations = '/business-insurance//declarations',

  Success = '/business-insurance/success',

  SocialWorker = '/business-insurance/business-activities/social-worker',
  ECA = '/business-insurance/business-activities/eca',
  ECA2 = '/business-insurance/business-activities/eca2',
  HRI = '/business-insurance/business-activities/hri',
  ENVCONSULTANT = '/business-insurance/business-activities/enviroment-consultant',
  ESV = '/business-insurance/business-activities/esv',

  // Construction industry routes
  C_Home = '/hired-in-plant',
  C_InsuranceType = '/hired-in-plant/insurance-type',
  C_PersonalDetails = '/hired-in-plant/personal-details',
  C_BusinessType = '/hired-in-plant/business-type',
  C_CompanySearch = '/hired-in-plant/company-search',
  C_BusinessActivities = '/hired-in-plant/business-activities',
  C_BusinessAddress = '/hired-in-plant/business-address',
  C_ProjectAddress = '/hired-in-plant/project-address',
  C_ProjectTimeline = '/hired-in-plant/project-timeline',
  C_ProjectMaintainance = '/hired-in-plant/project-maintenance',
  C_ProjectContractValue = '/hired-in-plant/project-contract-value',
  C_ProjectTradeActivities = '/hired-in-plant/project-trade-activities',
  C_ProjectActivitiesSplit = '/hired-in-plant/project-activities-split',
  C_ProjectExclusions = '/hired-in-plant/project-exclusions',
  C_CustomizeCover = '/hired-in-plant/customize-cover',
  C_CoverEstimate = '/hired-in-plant/cover-estimate',
  C_CoverLimit = '/hired-in-plant/cover-limit',
  C_CoverAsssumptions = '/hired-in-plant/cover-assumptions',
  C_CoverExcess = '/hired-in-plant/cover-excess',
  C_CoverStorage = '/hired-in-plant/cover-storage',
  C_HazardousActivities = '/hired-in-plant/hazardous-activities',
  C_PreviousInsurer = '/hired-in-plant/cover-insurer',
  C_ConfirmInformation = '/hired-in-plant/cover-confirm-information',
  C_CoverUsage = '/hired-in-plant/cover-usage',
  C_Success = '/hired-in-plant/success',

  // paths for dynamic routes

  // /quote/:quoteId/qset/:qsetId
  Stg1 = '/personal-details',
  Stg2 = '/business-type',
  Stg3 = '/company-search',
  'Stg3.1' = '/company-details',
  Stg4 = '/business-activities',
  'Stg4.1' = '/business-activities-additional',
  Stg5 = '/business-address',
  Stg6 = '/tech-industry',

  ContractDetails = '/contract-details',
  ClientDetails = '/contract-client',

  EstimatedIncome = '/estimated-income',

  Stg7 = '/business-turnover',
  Stg8 = '/business-employees',
  Stg9 = '/choose-cover',
  Stg10 = '/user-agreements',

  Stg11 = '/content-creation',
  Stg12 = '/contract-duration',
  Stg13 = '/contract-client',
  // Stg10 = '/payment-success',
  // Stg11 = '/business-customers',
  // Stg12 = '/business-customers-turnover',
  // Stg13 = '/additional-cover',
  Stg14 = '/confirm-information',
  // Stg15 = '/declarations',
  // Stg16 = '/success',

  // Hixcox routes
  HiscoxCompanyDetails = '/hiscox/company-details',
  HiscoxBusinessAddress = '/hiscox/business-address',
  HiscoxBusinessActivities = '/hiscox/business-activities',
  HiscoxEstimatedIncome = '/hiscox/estimated-income',
  HiscoxIncomeSplit = '/hiscox/income-split',
  HiscoxCustomizeCover = '/hiscox/customize-cover',
  HiscoxSenedEmail = '/hiscox/send-email',
  HiscoxSuccess = '/hiscox/success',
  HiscoxDeclarations = '/hiscox/declarations',
  HiscoxConfirmInformation = '/hiscox/confirm-information',
  HiscoxPayment = '/hiscox/payment',
  HiscoxTypeOfPolicy = '/hiscox/type-of-policy',
  HiscoxNumberOfEmployees = '/hiscox/employees',

  // Amlin routes
  AmlinTechIndustry = '/amlin/tech-industry',
  AmlinEstimatedIncome = '/amlin/estimated-income',
  AmlinBusinessEmployees = '/amlin/business-employees',
  AmlinIncomeSplit = '/amlin/income-split',
  AmlinCustomizeCover = '/amlin/customize-cover',
  AmlinQuestions = '/amlin/questions',
  AmlinDeclarations = '/amlin/declarations',
  AmlinPayment = '/amlin/payment',
  AmlinConfirmInformation = '/amlin/confirm-information',
  AmlinCompanyDetails = '/amlin/company-details',
}

export interface IRouteDefinition {
  name?: string;
  auth?: boolean;
  exact?: boolean;
  component: React.FC;
  path: string;
  computedMatch?: Record<string, unknown>;
}

export interface DeclarationProps {
  id: string;
  label: string;
  value: string;
}

export type Address = {
  postcode?: string;
  latitude?: number;
  longitude?: number;
  formatted_address?: string[];
  thoroughfare?: string;
  building_name?: string;
  sub_building_name?: string;
  sub_building_number?: string;
  building_number?: string;
  line_1?: string;
  line_2?: string;
  line_3?: string;
  line_4?: string;
  locality?: string;
  town_or_city?: string;
  county?: string;
  district?: string;
  country?: string;
  residential?: boolean;
  addressLine1?: string;
  addressLine2?: string;
};
